import { render, staticRenderFns } from "./TaskCaseOpenedFields.vue?vue&type=template&id=675caa66&"
import script from "./TaskCaseOpenedFields.vue?vue&type=script&lang=js&"
export * from "./TaskCaseOpenedFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports